// Keep recently visible cards mounted without growing to the whole inventory.
export function residentIndices(previous, center, reach, total, capacity = 32) {
  const current = [];
  for (let index = Math.max(0, center - reach - 1); index <= Math.min(total - 1, center + reach + 1); index += 1) current.push(index);
  const active = new Set(current);
  const recent = previous.filter(index => index >= 0 && index < total && !active.has(index));
  return [...recent, ...current].slice(-Math.max(capacity, current.length));
}
